import React, { useState } from "react";
import { motion } from "framer-motion";
import projectsData from "../../config";
import ProjectCard from "../Projects/ProjectCard";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

const ProjectCardAbout = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    const nextIndex = (currentSlide + 1) % projectsData.length;
    setCurrentSlide(nextIndex);
  };

  const prevSlide = () => {
    const prevIndex =
      (currentSlide - 1 + projectsData.length) % projectsData.length;
    setCurrentSlide(prevIndex);
  };

  return (
    <div className="flex sx:pb-40 flex-col flex-grow justify-center items-center overflow-x-clip rounded-xl p-4 relative">
      <div className=" flex  justify-center items-center w-full left-0 top-10 max-h-full ">
        {projectsData.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0 }}
            animate={{ opacity: index === currentSlide ? 1 : 0 }}
            transition={{ duration: 0.5 }}
            className="absolute transition-transform duration-700 ease-in-out"
            style={{ transform: index === currentSlide ? "translateX(0)" : "translateX(200vw)" }}
          >
            <ProjectCard
              details={project.detailOnCard}
              projectName={project.projectName}
            />
          </motion.div>
        ))}
      </div>

      <motion.button
        type="button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="absolute top-0 transition-all duration-500 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
        onClick={prevSlide}
      >
        <ArrowLeftIcon className="rounded-full hover:bg-gray-300 bg-slate-200 scale-150 hover:scale-[1.75] transition-all duration-500" />
      </motion.button>
      
      <motion.button
        type="button"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className="absolute top-0 end-0 transition-all duration-500 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
        onClick={nextSlide}
      >
        <ArrowRightIcon className="rounded-full scale-150 hover:bg-gray-300 bg-slate-200 hover:scale-[1.75] transition-all duration-500" />
      </motion.button>
    </div>
  );
};

export default ProjectCardAbout;
